import React from 'react';
import { shape } from 'prop-types';

import VehicleBodySelector from '../../vehicle-body-selector';
import { vehicleBodySelectorPropTypes } from '../../vehicle-body-selector/constants/prop-types';

/**
 * @param {Object} props
 * @param {import("../../vehicle-body-selector/constants/prop-types").VehicleBodySelectorProps?} props.intervention
 * @returns {JSX.Element?} The rendered component or null if no intervention is provided.
 */
const VehicleBodySelectorIntervention = ({ intervention }) => {
  if (!intervention) {
    return null;
  }

  return <VehicleBodySelector {...intervention} />;
};

VehicleBodySelectorIntervention.propTypes = {
  intervention: shape(vehicleBodySelectorPropTypes),
};

export default VehicleBodySelectorIntervention;
